import type { AxiosResponse } from "axios";

import api from "../../../../../api";
import { downloadCSV, validateValues } from "../../utils";
import type { IUser } from "../../../../../types";
import { CommandFormValues } from "../../types";
import { exportSmartaBankingTransactionsRequestSchema } from "./types";
import { buildExportFileName } from "@/v1/utils/exportFileName";
import { SAVE_DATE_FORMAT } from "@/v1/constants";

export const handleExportSmartaBankingTransactions = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { dateRange } = validateValues(
    values,
    exportSmartaBankingTransactionsRequestSchema
  );

  let from: string | undefined;
  let to: string | undefined;

  if (dateRange) {
    [from, to] = dateRange.map((date) => date.format(SAVE_DATE_FORMAT));
  }

  // Call the API method to export smarta banking transactions.
  const response = await api.kontax.exportSmartaBankingTransactions(
    user.id,
    from,
    to
  );
  // Extract the CSV
  const csv = response.data.csv;
  // Use the shared download helper to trigger the download.
  const fileName = buildExportFileName({
    user,
    exportType: "smarta Banking Transaktionen",
    period: from && to ? { kind: "dateRange", from, to } : undefined,
    extension: "csv",
  });
  downloadCSV(csv, fileName);
  return response;
};
